/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



document.addEventListener("DOMContentLoaded", function() {
  function debounceFunction (func, wait, immediate) { 
    var timeout;

    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  };
  var searchField = debounceFunction(function(e) {
    var el = e.target;
    var found_row = false;

    if(el.classList.contains('custom_search_form__input')) {
      var input_value = el.value;
      var input_downcaseVal = input_value.toLowerCase();
      var custom_search_form__list = el.nextElementSibling;
      if(custom_search_form__list) {
        var custom_search_form__listElements = custom_search_form__list.querySelectorAll('li');
      }

      if(input_value.length > 2) {
        if(custom_search_form__listElements.length) {
          custom_search_form__listElements.forEach(function(row,index) {
            var row_val = row.getAttribute('data-name');    
            var vendorLowerCaseValue = row_val.toLowerCase();
			

            if(vendorLowerCaseValue.indexOf(input_downcaseVal) >= 0 ) {
              found_row = true;
              
              var reg = new RegExp(input_value, 'gi');
              var new_val = row_val.replace(reg, function (str) {
                return "<span class='hightlighted'>".concat(str, "</span>");
              });
              row.querySelector('a').innerHTML = new_val;
              row.style.display = '';
            } else {
              row.style.display = 'none';
              row.querySelector('a').innerHTML = row_val;
            }


          });
        }
        if(found_row) {
        custom_search_form__list.classList.add('active_block');
        }

      } else {
        if(custom_search_form__listElements.length) {
          custom_search_form__listElements.forEach(function(row,index) {
            var row_val = row.getAttribute('data-name');    
            row.querySelector('a').innerHTML = row_val;
            row.style.display = '';
          });
        }
        custom_search_form__list.classList.remove('active_block');
      }
    }
  }, 300);
  
  var custom_search_form__input  = document.querySelector('.custom_search_form__input');
  if(custom_search_form__input) {
    custom_search_form__input.addEventListener('input', searchField);
  }

   
  document.addEventListener('click', function(e){
    var el = e.target;

    if(!el.classList.contains('custom_search_form_wrapper') && !el.closest('.custom_search_form_wrapper')) {
      var search_list_dropdown = document.querySelector('.custom_search_form__list.active_block');
      if(search_list_dropdown) {
      	search_list_dropdown.classList.remove('active_block');
      }
    }
  });
});




// Bundle Product page - Tap image to show second image

document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth > 999) return;

  document.querySelectorAll('.bundle-product-item .product-item__image-wrapper--with-secondary').forEach(function (wrapper) {
    const item = wrapper.closest('.bundle-product-item');
    if (!item) return;

    wrapper.addEventListener('click', function (e) {
      if (e.target.closest('input, label, button, a')) return;
      item.classList.toggle('image-toggled');
    });
  });
});


// Store last collection URL and club home URL for 'Continue Shopping' button in Cart

document.addEventListener('DOMContentLoaded', function () {
  var path = window.location.pathname;

  // Always store the parent collection path only
  if (path.indexOf('/collections/') === 0) {
    var parts = path.split('/');

    if (parts.length >= 3) {
      var collectionPath = '/collections/' + parts[2];
      localStorage.setItem('lastCollectionUrl', collectionPath);
    }
  }

  // Store the first breadcrumb collection link as club home fallback
  var clubHomeLink = document.querySelector('.breadcrumb__item:first-child .breadcrumb__link');
  if (clubHomeLink && clubHomeLink.getAttribute('href')) {
    var firstHref = clubHomeLink.getAttribute('href');

    if (firstHref.indexOf('/collections/') === 0) {
      localStorage.setItem('lastClubHomeUrl', firstHref);
    }
  }
});

